import get_Applications from './get_Applications';
import get_AssignedSocHelp from './get_AssignedSocHelp';
import get_Content from './get_Content';
import get_FAQ from './get_FAQ';
import get_HolderProfile from './get_HolderProfile';
import get_HolderPhoto from './get_HolderPhoto';
import get_ListAcceptors from './get_ListAcceptors';
import get_ListAcceptorCategories from './get_ListAcceptorCategories';
import get_ListLocalities from './get_ListLocalities';
import get_Login_Number from './get_Login_Number';
import get_ProfileSettings from './get_ProfileSettings';
import get_Notifications from './get_Notifications';
import get_Polls from './get_Polls';
import get_Polls_Number from './get_Polls_Number';
import get_ProvidingListApplications from './get_ProvidingListApplications';
import get_Requests from './get_Requests';
import get_Requests_Number from './get_Requests_Number';
import get_News from './get_News';
import get_News_Number from './get_News_Number';
import get_eCardInfo from './get_eCardInfo';
import get_Photo from './get_Photo';
import get_AcceptorBranches from './get_AcceptorBranches';

import post_Authorize from './post_Authorize';
import post_BlockCard from './post_BlockCard';
import post_SendCode from './post_SendCode';
import post_SetPassword from './post_SetPassword';
import post_CheckCode from './post_CheckCode';
import post_ChangeContacts from './post_ChangeContacts';
import post_ChangePassword from './post_ChangePassword';
import post_SendCodeFromCabinet from './post_SendCodeFromCabinet';
import post_Polls from './post_Polls';

import put_NotificationsStatusChange from './put_NotificationsStatusChange';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emptyArray: any = [];

export const mocks = {
  get_AcceptorBranches,
  get_AssignedSocHelp,
  get_Applications,
  get_Content,
  get_FAQ,
  get_HolderProfile,
  get_HolderPhoto,
  get_ListAcceptors,
  get_ListAcceptorCategories,
  get_ListLocalities,
  get_Login_Number,
  get_ProfileSettings,
  get_ProvidingListApplications,
  get_Notifications,
  get_Photo,
  get_Polls,
  get_Polls_Number,
  get_Requests,
  get_Requests_Number,
  get_News,
  get_News_Number,
  get_eCardInfo,
  post_Authorize,
  post_BlockCard,
  post_CheckCode,
  post_SendCode,
  post_SetPassword,
  post_ChangeContacts,
  post_ChangePassword,
  post_SendCodeFromCabinet,
  post_Polls,
  put_NotificationsStatusChange,
};
